module.exports = __webpack_public_path__ + "img/V01_ON.9051054e.jpg";